import React from "react";

/**
 * NEX wordmark — renders the compact NEX letters from the official
 * NEXENGINES lockup. Used at every on-page placement (header, hero,
 * footer, admin, checkout, etc). The full lockup with tagline
 * ("NEXENGINES" + "CUSTOM BUSINESS ENGINES • LIFE EMPOWERMENT INITIATIVE")
 * is reserved for OG social share previews and the favicon.
 *
 * The `size` prop maps a Tailwind text-* class to an approximate pixel
 * height so existing call sites (text-xl, text-2xl, text-6xl, etc.)
 * keep working unchanged. Aspect ratio is preserved.
 */
const SIZE_TO_HEIGHT = {
  "text-xs": 16,
  "text-sm": 20,
  "text-base": 24,
  "text-lg": 28,
  "text-xl": 32,
  "text-2xl": 40,
  "text-3xl": 52,
  "text-4xl": 64,
  "text-5xl": 80,
  "text-6xl": 96,
  "text-7xl": 120,
  "text-8xl": 160,
  "text-9xl": 200,
};

const NexWordmark = ({ className = "", size = "text-4xl" }) => {
  const height = SIZE_TO_HEIGHT[size];

  return (
    <img
      data-testid="nex-wordmark"
      src="/nex-mark.png"
      alt="NEX Engines"
      className={`nex-wordmark inline-block ${className}`}
      style={{
        height: height ? `${height}px` : undefined,
        width: "auto",
        maxWidth: "100%",
      }}
    />
  );
};

export default NexWordmark;
